import { reactive, ref, computed } from '@vue/composition-api'
import store from '@/store'
import { ESTIMATE_PRINT_DATA_NAME } from '@/util/constants'
import { getQueryParam } from '@/util/common'
import * as apiInquiry from '@/api/inquiry'
import * as apiProfile from '@/api/profile'

export const getGroup = (props, context) => {

  const group1 = reactive({

    isAuthorized: false, // 認証成功フラグ

    printType: '', // 印刷タイプ(estimate-final=お見積もり内容の確認、service-purchase=ライセンスの購入の確認)

    dateOfIssue: '', // 発行日
    totalFee: '', // 合計金額
    packageLists: [], // 購入リスト（お見積もり内容の確認用）

    /**
     * 初期表示
     */
    init: () => {

      // トークン
      const token = getQueryParam('token')

      // ローカルストレージのデータ(JSON)から印刷タイプの値を取得
      try {
        const printJSON = localStorage.getItem(ESTIMATE_PRINT_DATA_NAME)
        const printData = JSON.parse(printJSON)
        group1.printType = printData.print_type
      } catch (e) {
      }

      if (group1.printType === 'estimate-final') {
        // お見積もり内容確認入力画面と同様に
        // お見積もり内容確認APIを使用してトークンの認証をする
        const params = {}
        params.type = 1 // 1:入力画面
        params.token = token

        apiInquiry.confirmEstimate(params)
          .then((response) => {
            if (response) {
              const { data } = response
              if (data.status === 0) {
                // 認証OK
                group1.isAuthorized = true
              }
            }
          })
          .finally(() => {
            if (group1.isAuthorized) {
              // 認証OKの場合
              group1.outputContents()
            } else {
              // 認証NGの場合
              store.dispatch('common/showErrorInFullScreen', {title: '認証エラー', text: 'このページを表示する権限がありません。'})
            }
          })
      } else if (group1.printType === 'service-purchase') {

        // ストアにtokenの値を設定
        store.dispatch('auth/setToken', { token: token })

        // プロフィール取得APIを使用してトークンの認証をする
        const params = {}

        apiProfile.fetch(params) 
          .then((response) => {
            const { data } = response
            if (data.status === 0) {
              // 認証OK
              group1.isAuthorized = true
            }
          })
          .finally(() => {
            if (group1.isAuthorized) {
              // 認証OKの場合
              group1.outputContents()
            } else {
              // 認証NGの場合
              store.dispatch('common/showErrorInFullScreen', {title: '認証エラー', text: 'このページを表示する権限がありません。'})
            }
          })
      } else {
        store.dispatch('common/showErrorInFullScreen', {title: '認証エラー', text: 'このページを表示する権限がありません。'})
      }
    },

    outputContents: () => {

      // 発行日（今日の日付）
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth() + 1
      const mday = today.getDate()
      group1.dateOfIssue = year + '年' + month + '月' + mday + '日'

      // ローカルストレージから印刷データ(JSON)を取得する
      try {
        const printJSON = localStorage.getItem(ESTIMATE_PRINT_DATA_NAME)
        const printData = JSON.parse(printJSON)

        group1.printType = printData.print_type
        group1.name = printData.name
        group1.totalFee = printData.total_fee
        group1.packageLists = printData.package_lists
      } catch (e) {
      }
    }

  })

  return group1
}
